export const emailAttachmentTypes = Object.freeze({
    FILE: "FILE",
    TICKET: "TICKET",
});

export const senderTypes = {
    WORKSPACE_AGENT: "Agent",
    THIRD_USER: "Customer",
};
